import SpottedZebraLogo from 'assets/icons/spotted_zebra_logo.svg?react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Header.module.scss';

interface HeaderProps {
  showPartnerLogo?: boolean;
  companyLogoUrl?: string;
}

const Header: FC<HeaderProps> = ({ showPartnerLogo = true, companyLogoUrl }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.header}>
      <div className={styles.headerLogoLeft}>
        <SpottedZebraLogo className={styles.headerLogo} />
      </div>
      {showPartnerLogo && companyLogoUrl && (
        <div className={styles.headerLogoRight}>
          <img
            src={companyLogoUrl}
            alt={t('alt.companyLogoDefault')}
            className={styles.headerPartnerLogo}
          />
        </div>
      )}
    </div>
  );
};

export default Header;
